/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Card_PinnedInputs */



/**
* | output |
* | --- |
* | "Pinned" |
*
* @param {Community_Card_PinnedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_card_pinned = /** @type {((inputs?: Community_Card_PinnedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Card_PinnedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Épinglés")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fijados")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Fixados")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fissati")
	return /** @type {LocalizedString} */ ("Pinned")
});